export const LOAD_PRODUCT_DOMAIN_DATA       = 'LOAD_PRODUCT_DOMAIN_DATA';
export const UPDATE_PRODUCT_DOMAIN_DATA     = 'UPDATE_PRODUCT_DOMAIN_DATA';

export const CHANGE_SORTING                 = 'CHANGE_SORTING';
export const CHANGE_PAGE                    = 'CHANGE_PAGE';
export const CHANGE_CATEGORY_FILTER         = 'CHANGE_CATEGORY_FILTER';
export const ADD_FILTER                     = 'ADD_FILTER';
export const REMOVE_FILTER                  = 'REMOVE_FILTER';

export const ADD_PRODUCT_TO_CART            = 'ADD_PRODUCT_TO_CART';
export const CHANGE_PRODUCT_IN_CART         = 'CHANGE_PRODUCT_IN_CART';
export const REMOVE_PRODUCT_FROM_CART       = 'REMOVE_PRODUCT_FROM_CART';